import {
  KeyboardAwareScrollView as RNKeyboardAwareScrollView,
  KeyboardAwareScrollViewProps,
} from 'react-native-keyboard-aware-scroll-view';
import {withTheme} from '@rn-vui/themed';

export default withTheme<KeyboardAwareScrollViewProps>(
  RNKeyboardAwareScrollView,
  'KeyboardAwareScrollView',
);

declare module '@rn-vui/themed' {
  export interface ComponentTheme {
    KeyboardAwareScrollView: Partial<KeyboardAwareScrollViewProps>;
  }
}
